
define('text!TescoMobile_ClubCard/template/action-bar-clubcard-price.html',[],function () { return '<!-- ko if: clubCardPrice --><div class="monthly-total-clubcard clubcard-price-wrapper"><span data-bind="i18n: \'Clubcard Price\'" class="clubcard-price-label"></span> <span data-bind="text: $parent.getFormattedPrice(clubCardPrice)" class="clubcard-price-value"></span></div><!-- /ko -->';});

